import React from "react";
import ExperienceCard from "../../components/experienceCard/ExperienceCard.js";
import "./ExperienceList.css";

const ExperienceList = ({ sections, theme }) => {
  return (
    <div className="experience-list">
      {sections.map((section) => (
        <div key={section.title} className="experience-section">
          <h2
            style={{
              backgroundColor: theme.body,
              color: theme.text,
              borderBottom: `2px solid ${theme.headerColor}`,
              padding: "10px",
              marginBottom: "20px",
            }}
          >
            {section.title}
          </h2>
          <div className="experience-cards">
            {section.experiences.map((experience, index) => (
              <ExperienceCard
                key={index}
                index={index}
                totalCards={section.experiences.length}
                experience={experience}
                theme={theme}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ExperienceList;
